const TYPING_SPEEDS = {
    slow: 130,
    normal: 75,
    fast: 30,
};

export { TYPING_SPEEDS };
